// wondr grain — card quantity steppers, qty-aware add-to-cart, featured badge filter
(() => {
  'use strict';

  // Quantity steppers on product cards / reel strips
  document.addEventListener('click', (e) => {
    const inc = e.target.closest('[data-cqty-inc]');
    const dec = e.target.closest('[data-cqty-dec]');
    if (!inc && !dec) return;
    const box = (inc || dec).closest('.qty--card');
    const out = box && box.querySelector('[data-cqty]');
    if (!out) return;
    let n = parseInt(out.textContent, 10) || 1;
    n = inc ? Math.min(99, n + 1) : Math.max(1, n - 1);
    out.textContent = n;
  });

  // Qty-aware add: capture phase so it runs before the default single-add handler
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add]');
    if (!btn || !btn.dataset.variant) return;
    const scope = btn.closest('.card-buy, .prod-foot, .reel-shop');
    const out = scope && scope.querySelector('[data-cqty]');
    const q = out ? (parseInt(out.textContent, 10) || 1) : 1;
    if (q <= 1) return; // default handler adds 1
    e.stopPropagation();
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const add = (window.WG_ROUTES && window.WG_ROUTES.cartAdd) || '/cart/add';
      const res = await fetch(add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variant, 10), quantity: q }] })
      });
      if (!res.ok) throw new Error('add failed');
      const cartUrl = (window.WG_ROUTES && window.WG_ROUTES.cart) || '/cart';
      const cart = await (await fetch(cartUrl + '.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      btn.textContent = 'Added ✓';
      if (out) out.textContent = '1';
    } catch (err) {
      btn.textContent = 'Try again';
    }
    setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1400);
  }, true);

  // Featured section: badge filter chips
  document.querySelectorAll('[data-badge-chips]').forEach((wrap) => {
    wrap.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-filter]');
      if (!chip) return;
      wrap.querySelectorAll('[data-filter]').forEach((c) => c.classList.toggle('active', c === chip));
      const grid = document.querySelector(wrap.dataset.target);
      if (!grid) return;
      const f = chip.dataset.filter;
      grid.querySelectorAll('[data-badge]').forEach((el) => {
        el.style.display = (f === 'all' || el.dataset.badge === f) ? '' : 'none';
      });
    });
  });
})();
